import { createI18n } from 'vue-i18n';
import locales from './locales';
import { storageService } from './common/services/storage/storageService';
import type { Locale } from './locales/i18nTypes';

// Define supported locales
export const SUPPORTED_LOCALES: Locale[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
];

// Get saved locale from storage or default to 'en'
const getInitialLocale = (): string => {
  const savedLocale = storageService.getItem('locale');
  if (savedLocale && SUPPORTED_LOCALES.some((locale) => locale.code === savedLocale)) {
    return savedLocale;
  }

  // Try to detect browser language
  const browserLang = navigator.language.split('-')[0];
  if (SUPPORTED_LOCALES.some((locale) => locale.code === browserLang)) {
    return browserLang;
  }

  return 'fr'; // Default fallback
};

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getInitialLocale(),
  fallbackLocale: 'fr',
  messages: locales as any,
});

export default i18n;

// Helper function to change locale and persist it
export const setLocale = (locale: string) => {
  if (SUPPORTED_LOCALES.some((l) => l.code === locale)) {
    (i18n.global.locale as any).value = locale;
    storageService.setItem('locale', locale);

    // Update document language attribute for accessibility
    document.documentElement.lang = locale;
  }
};

// Helper function to get available locales
export const getAvailableLocales = (): Locale[] => {
  return SUPPORTED_LOCALES;
};
